export default {
  'newUser.addUserTitle': 'Add New User',
  'newUser.admin': 'Admin',
  'newUser.user': 'User',
  'newUser.header': 'DEFINE USER',

  'newUser.editUserTitle': 'Modify User',
  'newUser.continueToSummary': 'Continue to Summary',
  'newUser.viewUserTitle': 'View User Permissions',

  // messages
  'newUser.codeExistsError': 'User ID already exists',
  'newUser.codeError': 'User code can only contain letters and numbers',
  'newUser.selectState': 'Select a state',
  'newUser.msgRequired': 'Required field cannot be blank',
  'newUser.msgEmail': 'Invalid email address',
  'newUser.msgPassword': 'The password fields must match.',
  'newUser.msgPasswordLength': 'Password must be between <%=min %> and <%=max %> characters.',

  'newUser.msgCode': 'User code can only contain letters and numbers',
  'newUser.msgCreated': 'User has been created',
  'newUser.msgCreatedDualApprove':
    'User is created. Changes are waiting for Secondary Admin Approval.',
  'newUser.msgField': 'Field can only contain letters, numbers and underscore',
  'newUser.msgPasswordHasCustomerId': 'Password cannot contain Customer ID',
  'newUser.msgPasswordHasUserId': 'Password cannot contain User ID',
  'newUser.msgPasswordHasUserName': 'Password cannot contain User Name',
  'newUser.msgPhone': 'Phone number can only contain numbers, dash, space, dot and brackets',
  'newUser.msgUpdated': 'User has been modified',
  'newUser.msgUpdatedDualApprove':
    'User is updated. Changes are waiting for Secondary Admin Approval.',
  'newUser.msgChangingUserTypeIsNotAllowed':
    'Please contact your financial institution if you wish to update User Type',
  'newUser.emailOTPDisallowed.phone.helperText': '* Used to receive one-time passcode.',

  'newUser.userDataLabel': 'user',
  'newUser.servicesLabel': 'services',
  'newUser.accountsPermissionsLabel': 'account level permissions',
  'newUser.achPermissionsLabel': 'ACH permissions',
  'newUser.reportsPermissionsLabel': 'reports permissions',
  'newUser.statementsPermissionsLabel': 'statements permissions',
  'newUser.limitsLabel': 'limits',
  'newUser.errorDuringSaving': 'Error occurred during <%=requests%> saving',

  'newUser.addAddressLine': 'Add address line',
  'newUser.optional': 'Optional',
  'newUser.cancel': 'Cancel',
  // headers
  'newUser.address': 'Address',
  'newUser.address1': 'Address Line 1',
  'newUser.address2': 'Address Line 2',
  'newUser.accountPermissions': 'Account Permissions',
  'newUser.achPermissions': 'ACH Permissions',
  'newUser.achSenderId': 'ACH Sender Id',
  'newUser.addFields': 'Add Contact Fields',
  'newUser.amountLimitBatch': 'AMOUNT LIMIT (PER BATCH)',
  'newUser.contactInfo': 'Contact Information',
  'newUser.generatedPassword': 'System Generated Password',
  'newUser.passwordInfo': 'Password',
  'newUser.reportPermissions': 'Report Permissions',
  'newUser.statements': 'Statements',
  'newUser.reviewUserChanges': 'Review User Changes',
  'newUser.reviewUserInformation': 'Review User Information',
  'newUser.sendPassword': 'Send password via email',
  'newUser.sendPasswordAlt': 'Send Password',
  'newUser.servicesAndPermissions': 'Services & Permissions',
  'newUser.settings': 'Settings',
  'newUser.settingsInfo': 'User Settings',
  'newUser.userDetails': 'User Details',
  'newUser.userInfo': 'User Information',
  'newUser.signOnInfo': 'Single Sign On information',
  'newUser.achExemption': 'ACH Exemption',
  'newUser.wireExemption': 'Wire Exemption',
  'newUser.achApprovalExemption': 'Ach Approval Exemption',
  'newUser.wireApprovalExemption': 'Wire Approval Exemption',

  // labels
  'newUser.userType': 'User Type',
  'newUser.enabledFrom': 'Enable Date',
  'newUser.userCredential1': 'User Credential 1',
  'newUser.userCredential2': 'User Credential 2',
  'newUser.service': 'Service Name',
  'newUser.repeatPassword': 'Repeat New Password',
  'newUser.gotToServicesAndPermissions': 'Go to Services & Permission',
  'newUser.gotToEntitlements': 'Go to Entitlements',
  'newUser.goToLimits': 'Go to Limits',
  'newUser.goToUserDetails': 'Go to User Details',
  'newUser.preparingForPrint': 'Preparing Summary for print',
  'newUser.aria.editProfileButton': 'Edit <%= user %> profile',

  // modal
  'newUser.modal.areYouSureLivePage': 'Are you sure you want to leave this page?',
  'newUser.modal.changesWillBeLost': 'All unsaved changes will be lost.',
  'newUser.modal.leavePage': 'Leave Page',

  // vip token
  'newUser.vipTokenLabel': 'VIP Token Settings',
  'newUser.vipTokenLabelAssign':
    'Assign a token serial number after completing the new user setup.',
  'newUser.vipTokenSerialNumber': ' Token serial number',
  'newUser.vipTokenDynamicText': '  <%=currentState %>  Token',
  'newUser.invalidToken': 'Invalid Token',
  'newUser.tokenUpdateSuccess': 'VIP token serial number updated successfully',
  'newUser.tokenStateSuccess': 'VIP token State updated successfully',
  'newUser.tokenStateError': 'Error during token state update',
  'newUser.tokenPendingActivation':
    'Token pending activation. The user will be asked to activate the token next time they are challenged.',
  'newUser.enableToken': 'Enable Token'
};
